<template>
  <modal name="paymentInfo" v-bind:width="400" v-bind:height="572" v-bind:clickToClose="false"
         v-on:before-open="beforeOpen" v-on:before-close="beforeClose">
    <div class="paymentInfoWrapper">
      <div class="paymentInfoTop">
        <img v-bind:src="closeIcon" v-on:click="modalClose">
      </div>
      <div class="paymentInfoHeader">
        <span>포인트 충전하기</span>
      </div>
      <div class="paymentInfoTOSWrapper" v-show="step === 0">
        <div class="paymentInfoItemNameDiv">
          <span class="itemName">이용약관</span>
        </div>
        <div class="paymentInfoTOSDetailDiv">
          <span v-html="paymentTosText"></span>
        </div>
        <div class="paymentInfoTOSConfirmDiv">
          <img v-bind:src="tosConfirmCheckIcon" v-on:click="onCheckTosConfirm">
          <span>약관에 동의합니다.</span>
        </div>
      </div>
      <div class="paymentInfoFeeWrapper" v-show="step === 1">
        <div>
          <div class="paymentInfoItemNameDiv">
            <span class="itemName">현재 보유포인트</span>
          </div>
          <div class="paymentInfoNowAdPointDiv">
            <span>{{nowAdPoint == null ? 0 : nowAdPoint.toLocaleString() + '원'}}</span>
          </div>
        </div>
        <div class="paymentInfoFeeDiv">
          <div class="paymentInfoItemNameDiv">
            <span class="itemName">충전금액</span>
          </div>
          <div class="paymentInfoFeeSelectDiv">
            <div class="selectDiv" v-for="feeOption in feeOptions" v-bind:key="feeOption.index">
              <div class="pointAndFeeInfo">
                <div class="pointInfo">
                  <img v-bind:src="feeOption.checkIcon" v-on:click="onCheckFeeOption(feeOption.index)">
                  <span>{{feeOption.value == null ? 0 : feeOption.value.toLocaleString() + '포인트'}}</span>
                </div>
                <div class="feeInfo">
                  <span>{{feeOption.value == null ? 0 : feeOption.value.toLocaleString() + '원'}}</span>
                </div>
              </div>
              <div class="bonusPointInfo">
                <span v-show="feeOption.bonusPoint !== 0">{{'+ ' + (feeOption.bonusPoint == null ? 0 : feeOption.bonusPoint.toLocaleString()) + '포인트'}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="paymentInfoMethodAndConfirmWrapper" v-show="step === 2">
        <div class="paymentInfoMethodDiv">
          <div class="paymentInfoItemNameDiv">
            <span class="itemName">결제수단 선택</span>
          </div>
          <div class="methodDiv" v-for="methodOption in methodOptions" v-bind:key="methodOption.index">
            <img v-bind:src="methodOption.checkIcon" v-on:click="onCheckMethodOption(methodOption.index)">
            <span>{{methodOption.methodName}}</span>
          </div>
        </div>
        <div class="paymentInfoPhoneNumDiv">
          <div class="paymentInfoItemNameDiv">
            <span class="itemName">휴대전화번호 입력</span>
          </div>
          <div class="phoneNumDiv">
            <input class="phoneNumInput" type="text" ref="inputPhoneNum0" v-bind:maxlength="3" v-bind:value="inputPhoneNum[0]" v-on:keydown="onlyNumber" v-on:keydown.tab="pressTabKey(0)" v-on:blur="setPhoneNum(0)" v-bind:style="'margin-left: 0px;'">
            <span>{{'-'}}</span>
            <input class="phoneNumInput" type="text" ref="inputPhoneNum1" v-bind:maxlength="4" v-bind:value="inputPhoneNum[1]" v-on:keydown="onlyNumber" v-on:keydown.tab="pressTabKey(1)" v-on:blur="setPhoneNum(1)">
            <span>{{'-'}}</span>
            <input class="phoneNumInput" type="text" ref="inputPhoneNum2" v-bind:maxlength="4" v-bind:value="inputPhoneNum[2]" v-on:keydown="onlyNumber" v-on:keydown.tab="pressTabKey(2)" v-on:blur="setPhoneNum(2)">
          </div>
        </div>
        <div class="paymentInfoConfirmDiv">
          <div class="paymentInfoItemNameDiv">
            <span class="itemName">결제진행 동의(필수)</span>
          </div>
          <div class="confirmDiv">
            <img v-bind:src="confirmCheckIcon" v-on:click="onCheckConfirm">
            <span>결제진행에 동의합니다</span>
          </div>
        </div>
      </div>
      <div class="paymentInfoResultWrapper" v-show="step === -1 || step === 98 || step === 99">
        <span v-if="step === -1">결제에 실패하셨습니다.<br><br>처음부터 다시 이용해주세요.</span>
        <span v-if="step === 98">
          {{'가상계좌정보를 확인해주세요.'}}
          <br><br><br><br>{{'가상계좌은행: ' + vBankData.vBankName}}
          <br><br>{{'가상계좌번호: ' + vBankData.vBankNum}}
          <br><br>{{'납입금액: ' + vBankData.vBankAmount}}
          <br><br>{{'납입기한: ' + vBankData.vBankDate}}
        </span>
        <span v-if="step === 99">결제가 완료되었습니다.</span>
      </div>
      <div class="paymentInfoFooter">
        <button class="paymentInfoNextBtn" v-bind:disabled="setDisable" v-on:click="onNext">{{step === -1 || step === 98 || step === 99 ? '닫기' : '다음'}}</button>
      </div>
    </div>
  </modal>
</template>

<script>
import params from '../../../params'

export default {
  data () {
    return {
      step: null,
      closeIcon: require('@/assets/img/modal_close_icon.png'),
      tosConfirmCheckIcon: null,
      paymentTosText: params.paymentTosText,
      isTosConfirmed: null,
      nowAdPoint: null,
      feeOptions: [],
      selectedFeeIndex: null,
      methodOptions: [],
      inputPhoneNum: [],
      phoneNumChangedFlag: null,
      selectedMethodIndex: null,
      confirmCheckIcon: null,
      isConfirmed: null,
      vBankData: null
    }
  },
  methods: {
    beforeOpen: function () {
      this.isTosConfirmed = false
      this.step = 0
      this.tosConfirmCheckIcon = require('@/assets/img/checkbox_not_selected_img.png')
      this.nowAdPoint = this.$store.getters.getAdUserStateValue('adPoint')
      this.feeOptions = [
        {
          index: 0,
          value: 10000,
          bonusPoint: 0,
          checkIcon: require('@/assets/img/checkbox_not_selected_img.png')
        },
        {
          index: 1,
          value: 30000,
          bonusPoint: 1000,
          checkIcon: require('@/assets/img/checkbox_not_selected_img.png')
        },
        {
          index: 2,
          value: 50000,
          bonusPoint: 3000,
          checkIcon: require('@/assets/img/checkbox_not_selected_img.png')
        },
        {
          index: 3,
          value: 100000,
          bonusPoint: 10000,
          checkIcon: require('@/assets/img/checkbox_not_selected_img.png')
        }
      ]
      this.selectedFeeIndex = null
      this.methodOptions = [
        {
          index: 0,
          methodName: '카드결제',
          checkIcon: require('@/assets/img/checkbox_not_selected_img.png')
        },
        {
          index: 1,
          methodName: '계좌이체',
          checkIcon: require('@/assets/img/checkbox_not_selected_img.png')
        },
        {
          index: 2,
          methodName: '가상계좌',
          checkIcon: require('@/assets/img/checkbox_not_selected_img.png')
        }
      ]
      this.inputPhoneNum = [
        '010', '', ''
      ]
      this.phoneNumChangedFlag = false
      this.selectedMethodIndex = null
      this.confirmCheckIcon = require('@/assets/img/checkbox_not_selected_img.png')
      this.isConfirmed = false
    },
    beforeClose: function () {
      this.$store.commit('setPaymentReq', {result: null})
      this.$store.commit('setMerchantId', {merchantId: null})
      this.$store.commit('setPaymentMethod', {paymentMethod: null})
      this.$store.commit('setVBankData', {vBankDate: null, vBankName: null, vBankNum: null, vBankAmount: null})
      this.vBankData = null
    },
    onCheckTosConfirm: function () {
      this.tosConfirmCheckIcon = this.isTosConfirmed ? require('@/assets/img/checkbox_not_selected_img.png') : require('@/assets/img/checkbox_selected_img.png')
      this.isTosConfirmed = !this.isTosConfirmed
    },
    onCheckFeeOption: function (checkBoxIndex) {
      this.feeOptions.forEach(items => {
        items.checkIcon = items.index === checkBoxIndex ? require('@/assets/img/checkbox_selected_img.png') : require('@/assets/img/checkbox_not_selected_img.png')
      })
      this.selectedFeeIndex = checkBoxIndex
    },
    onCheckMethodOption: function (checkBoxIndex) {
      this.methodOptions.forEach(items => {
        items.checkIcon = items.index === checkBoxIndex ? require('@/assets/img/checkbox_selected_img.png') : require('@/assets/img/checkbox_not_selected_img.png')
      })
      this.selectedMethodIndex = checkBoxIndex
    },
    onlyNumber: function (e) {
      if(!((e.keyCode > 47 && e.keyCode < 58) || (e.keyCode > 95 && e.keyCode < 106) || (e.keyCode > 36 && e.keyCode < 41) || e.keyCode === 8 || e.keyCode === 46)) {
        e.returnValue = false
      }
    },
    pressTabKey: function (index) {
      if(index !== 2) {
        this.$refs['inputPhoneNum' + (index + 1)].focus()
      }else {
        this.$refs['inputPhoneNum' + index].blur()
      }
    },
    setPhoneNum: function (index) {
      let inputVal = this.$refs['inputPhoneNum' + index].value
      let convertedInputVal = inputVal.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '')
      // eslint-disable-next-line no-useless-escape
      convertedInputVal = convertedInputVal.replace(/[\{\}\[\]\/?.,;:|\)*~`!^\-+<>@\#$%&\\\=\(\'\"]/gi, '')
      this.$refs['inputPhoneNum' + index].value = convertedInputVal
      this.inputPhoneNum[index] = convertedInputVal
      this.phoneNumChangedFlag = !this.phoneNumChangedFlag
    },
    onCheckConfirm: function () {
      this.confirmCheckIcon = this.isConfirmed ? require('@/assets/img/checkbox_not_selected_img.png') : require('@/assets/img/checkbox_selected_img.png')
      this.isConfirmed = !this.isConfirmed
    },
    onNext: function () {
      // 결제 실패, 성공일 경우 step그대로, 아닐경우 +1하여 다음스텝
      this.step = (this.step === -1 || this.step === 98 || this.step === 99) ? this.step : this.step + 1
      if(this.step === 3) {
        // 결제화면 띄움
        let payMethod = this.selectedMethodIndex === 0 ? 'card' : (this.selectedMethodIndex === 1 ? 'trans' : 'vbank')
        let amount = this.selectedFeeIndex === 0 ? 10000 : (this.selectedFeeIndex === 1 ? 30000 : (this.selectedFeeIndex === 2 ? 50000 : 100000))
        let phoneNum = this.inputPhoneNum
        this.openRequestPayWindow(payMethod, amount, phoneNum)
      }else if (this.step === -1) {
        // 결제 실패
        this.modalClose()
        // 페이지 새로고침
        this.$router.go()
      }else if (this.step === 98 || this.step === 99) {
        // 결제 성공
        this.modalClose()
        // 페이지 새로고침
        this.$router.go()
      }
    },
    openRequestPayWindow: async function (payMethod, amount, phoneNum) {
      let IMP = window.IMP
      let merchantDataResponse = await this.$store.dispatch('createMerchantDataApi', {pg: 'danal', payMethod: payMethod, amount: amount})
      let merchantId = merchantDataResponse.data.data.merchantId
      // let merchantId = '31322sss-fff'
      this.$store.commit('setMerchantId', {merchantId: merchantId})
      let bizNum = this.$store.getters.getBizNum
      let buyerName = this.$store.getters.getAdUserStateValue('name')
      let pointAmount = amount === 10000 ? 10000 : (amount === 30000 ? 31000 : (amount === 50000 ? 53000 : 110000))
      let data = {
        pg: 'danal_tpay',
        pay_method: payMethod, // card(신용카드), trans(실시간계좌이체), vbank(가상계좌), phone(휴대폰소액결제)
        merchant_uid: merchantId,
        name: pointAmount + '포인트',
        amount: amount,
        buyer_name: buyerName,
        buyer_tel: phoneNum[0] + '-' + phoneNum[1] + '-' + phoneNum[2], // 누락되면 카드사 인증에 실패할 수 있음
        biz_num: bizNum
      }

      IMP.request_pay(data, async function (rsp) {
        if (rsp.success) {
          try {
            console.log(rsp)
            window.store.commit('setPaymentMethod', {paymentMethod: rsp.pay_method})
            if(rsp.pay_method === 'vbank') {
              // 가상계좌 이용시
              window.store.commit('setVBankData', {vBankDate: rsp.vbank_date, vBankName: rsp.vbank_name, vBankNum: rsp.vbank_num, vBankAmount: rsp.paid_amount})
            }

            // 결제정보 서버 전달
            await window.store.dispatch('completePaymentApi', {impUid: window.store.getters.getIMPCode, merchantId: window.store.getters.getMerchantId})

            // 결제요청 완료 처리
            window.store.commit('setPaymentReq', {result: true})
          }catch (error) {
            console.log(error)
            // 결제 실패시
            window.store.commit('setPaymentReq', {result: false})
          }
        } else {
          // 결제 실패시
          console.log(rsp)
          window.store.commit('setPaymentReq', {result: false})
        }
      })
    },
    modalClose: function () {
      this.$modal.hide('paymentInfo')
    }
  },
  computed: {
    setDisable: function () {
      if(this.step === 0) {
        return !this.isTosConfirmed
      }else if(this.step === 1) {
        return this.selectedFeeIndex == null
      }else if (this.step === 2) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.phoneNumChangedFlag = !this.phoneNumChangedFlag
        return !this.isConfirmed || this.selectedMethodIndex == null || (this.inputPhoneNum[0] === '' || this.inputPhoneNum[1] === '' || this.inputPhoneNum[2] === '')
      }
      return false
    }
  },
  mounted: function () {
    let IMP = window.IMP
    let IMPCode = this.$store.getters.getIMPCode
    IMP.init(IMPCode)

    this.$store.watch(() => this.$store.getters.getPaymentReq, value => {
      // 결제진행창 결과 및 결제방법에 따른 step 값 할당
      if(value && (this.$store.getters.getPaymentMethod === 'card' || this.$store.getters.getPaymentMethod === 'trans')) {
        this.step = 99
      }else if(value && this.$store.getters.getPaymentMethod === 'vbank') {
        this.vBankData = this.$store.getters.getVBankData
        this.step = 98
      }else{
        this.step = -1
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.paymentInfoWrapper {
  display : -webkit-flex;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
}

.paymentInfoTop {
  display : -webkit-flex;
  display: flex;
  justify-content: flex-end;
  height: 32px;
  padding-top: 12px;
  padding-right: 12px;
}

.paymentInfoTop > img {
  cursor: pointer;
  height: 100%;
  width: auto;
}

.paymentInfoHeader {
  display : -webkit-flex;
  display: flex;
  flex-direction: column;
  padding: 0 32px;
  font-size: 24px;
}

.itemName {
  font-size: 11px;
  color: rgb(0,153,255);
}

.paymentInfoTOSWrapper, .paymentInfoFeeWrapper, .paymentInfoMethodAndConfirmWrapper {
  display : -webkit-flex;
  display: flex;
  flex-direction: column;
  height: 390px;
  padding: 0 32px;
}

.paymentInfoResultWrapper{
  display : -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 390px;
  padding: 0 32px;
}

.paymentInfoItemNameDiv {
  margin-top: 14px;
}

.paymentInfoTOSDetailDiv {
  height: 238px;
  width: calc(100% - 36px);
  border: 1px black solid;
  margin-top: 16px;
  padding: 18px;
  font-size: 11px;
  overflow-y: auto;
}

.paymentInfoTOSDetailDiv::-webkit-scrollbar {
  width: 12px;
}
.paymentInfoTOSDetailDiv::-webkit-scrollbar-thumb {
  background-color: #000000;
}
.paymentInfoTOSDetailDiv::-webkit-scrollbar-track {
  background-color: #EFEFEF;
}

.paymentInfoTOSConfirmDiv {
  display : -webkit-flex;
  display: flex;
  align-items: center;
  margin-top: 24px;
}

.paymentInfoTOSConfirmDiv > img {
  cursor: pointer;
  width: 32px;
  height: 32px;
}

.paymentInfoTOSConfirmDiv > span {
  font-size: 13px;
  margin-left: 8px;
}

.paymentInfoNowAdPointDiv {
  margin: 12px 0;
}

.paymentInfoNowAdPointDiv > span{
  font-size: 15px;
  font-weight: bold;
}

.paymentInfoFeeSelectDiv {
  margin-top: 10px;
  height: 256px;
}

.selectDiv{
  display : -webkit-flex;
  display: flex;
  flex-direction: column;
  height: 68px;
}

.pointAndFeeInfo {
  display : -webkit-flex;
  display: flex;
  justify-content: space-between;
}

.pointInfo {
  display : -webkit-flex;
  display: flex;
  align-items: center;
}

.pointInfo > img{
  cursor: pointer;
  width: 32px;
  height: 32px;
}

.pointInfo > span{
  margin-left: 8px;
  font-size: 13px;
}

.feeInfo > span{
  font-size: 13px;
  font-weight: bold;
}

.bonusPointInfo {
  display : -webkit-flex;
  display: flex;
  align-items: center;
}

.bonusPointInfo > span{
  margin-left: 40px;
  font-size: 13px;
  color: #0099FF;
}

.methodDiv, .confirmDiv, .phoneNumDiv {
  display : -webkit-flex;
  display: flex;
  align-items: center;
  margin-top: 16px;
}


.methodDiv > img, .confirmDiv > img{
  cursor: pointer;
  width: 32px;
  height: 32px;
}

.methodDiv > span, .confirmDiv > span{
  margin-left: 8px;
  font-size: 13px;
}

.paymentInfoConfirmDiv {
  margin-top: 16px;
}

.phoneNumInput  {
  font-size: 13px;
  width: 60px;
  border: 1px solid black;
  border-radius: 0.3rem;
  text-align: center;
  padding: 4px 0;
  margin: 0 6px;
}

.paymentInfoFooter{
  display : -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 103px;
}

.paymentInfoNextBtn{
  cursor: pointer;
  margin-left: 0;
  width: 196px;
  height: 50px;
  font-weight: bold;
  font-size: 15px;
  border: 2px solid rgb(0,153,255);
  border-radius: 0.3rem;
  color: white;
  outline: none;
  background-color: rgb(0,153,255);
}

.paymentInfoNextBtn:disabled{
  cursor: default;
  border: 2px solid rgb(207,207,207);
  border-radius: 0.3rem;
  color: white;
  outline: none;
  background-color: rgb(207,207,207);
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/paymentInfoModal.vue